module.exports = __webpack_public_path__ + "static/6305-woodrose-22-04f863c235425e759f9fb70c1db9d7da.jpg";